export default class FrontPageEnum {
    static CONTAINER_INSPIRATIONS = '#strate-inspirations'
    static CONTAINER_KEYWORDS = '#strate-keywords'
    static TRIGGER_CARDS = '[data-discover-trigger]'
    static THUMB_CARDS = '[data-discover-thumb]'
    static CONTAINER_AGENDA = '#strate-agenda'
}
